// extracted by mini-css-extract-plugin
export var box = "_95-1";
export var checked = "_95-2";
export var descriptionSpacer = "_95-9";
export var disabled = "_95-3";
export var icon = "_95-6";
export var input = "_95-0";
export var labelSpacer = "_95-8";
export var medium = "_95-5";
export var small = "_95-4";
export var text = "_95-7";